import Cookies from 'js-cookie';

export default {
  set: (auth: string): string | undefined => Cookies.set('auth', auth, { expires: 30 }),
  get: (): string | undefined => Cookies.get('auth'),
  remove: () => Cookies.remove('auth'),
};
